var render = function (_h,_vm) {var _c=_vm._c;return _c('v-card',{attrs:{"width":"100%"}},[_c('v-card-title',{staticClass:"pb-1"},[_vm._v(_vm._s(_vm.props.heading))]),_c('v-card-text',{staticClass:"primary--text text--lighten-1 display-2 font-weight-medium"},[_vm._v(_vm._s(_vm.props.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }